import { render, staticRenderFns } from "./improveAfterSalesInformationList.vue?vue&type=template&id=2e787eb6&scoped=true"
import script from "./improveAfterSalesInformationList.vue?vue&type=script&lang=js"
export * from "./improveAfterSalesInformationList.vue?vue&type=script&lang=js"
import style0 from "./improveAfterSalesInformationList.vue?vue&type=style&index=0&id=2e787eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e787eb6",
  null
  
)

export default component.exports